<template>
  <viewOperario />
</template>

<script>
import viewOperario from "@/views/documents/viewUser.vue";

export default {
  components: {
    viewOperario,
  },
  data() {
    return {
    };
  },
  computed: {
  },
  created() {
  },
  methods: {
  },
};
</script>
